<!--
 * @Description:
 * @Author: Xyyyyyy
 * @Date: 2023-09-05 13:45:08
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-09-05 17:15:49
-->
<!--
 * @Description: 临时工作任务 详情
 * @Author: ZSC
 * @Date: 2023-03-29 13:47:53.795
 * @LastEditors: wanglixin wang1223634360@163.com
 * @LastEditTime: 2023-05-22 16:48:05
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="w800 h630" :model-value="openWeiPaiDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openWeiPaiDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="工作任务标题" label-align="right" align="left" width="120px" span="2">{{ruleForm.gzrwbt}}</el-descriptions-item>
        <el-descriptions-item label="部门" label-align="right" align="left" width="120px" span="2">{{ruleForm.bmmc}}</el-descriptions-item>
        <el-descriptions-item label="负责人" label-align="right" align="left" width="120px" span="2">{{ruleForm.fzrxm}}</el-descriptions-item>
        <el-descriptions-item label="工作任务状态" label-align="right" align="left" width="140px" span="2">
          <div v-for="(item, index) in ztData" :key="index">
            <span v-if="ruleForm.zt == item.value">{{item.name}}</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="要求完成时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.yqwcsj}}</el-descriptions-item>
        <el-descriptions-item label="开始时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.kssj}}</el-descriptions-item>
        <el-descriptions-item label="完成时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.wcsj}}</el-descriptions-item>
        <el-descriptions-item label="委派人" label-align="right" align="left" width="120px" span="2">{{ruleForm.wprxm}}</el-descriptions-item>
        <el-descriptions-item label="委派时间" label-align="right" align="left" width="120px" span="2">{{ruleForm.wpsj}}</el-descriptions-item>
        <el-descriptions-item label="待办内容" label-align="right" align="left" width="120px" span="4">
          <p class="fu-wen-ben-yu-lan" style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.dbnr"></p>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer-but">
            <el-button type="info" @click="closeWindow('openWeiPaiDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, loadSelect } from '@/api/common.js'

const props = defineProps({
  openWeiPaiDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openWeiPaiDetail'])
// const gzrwztData = ref([])
const ztData = ref([])
// const ztData = ref({ listZhuangTai: [] })

watch(
  () => props.openWeiPaiDetail,
  () => {
    if (props.openWeiPaiDetail) {
      // loadSelect({
      //   url: '/api/v2/bangong/gerengongzuorenwu/gongzuorenwuzhuangtai',
      //   data: gzrwztData,
      //   loadSuccess: function (res) {
      //     ztData.value = res.data.listZhuangTai
      //   }
      // })
      loadSelect({
        url: '/api/v2/bangong/bangongdaibanshixiang/daibanzhuangtai',
        data: ztData,
        // order: 'gzlbmc',
        // sort: 'asc'
        loadSuccess: function (res) {
          ztData.value = res.data.listZhuangTai
        }
      })
      loadData({
        url: '/api/v2/bangong/bangonglinshidaibanshixiang/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
